import { render, staticRenderFns } from "./moveOtherlist.vue?vue&type=template&id=15a0b95d&scoped=true&"
import script from "./moveOtherlist.vue?vue&type=script&lang=js&"
export * from "./moveOtherlist.vue?vue&type=script&lang=js&"
import style0 from "./moveOtherlist.vue?vue&type=style&index=0&id=15a0b95d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a0b95d",
  null
  
)

export default component.exports